import React from 'react';
import {getDateStyle, isDatePassed, getDatePastDueText, pastDueStyle} from './CorrectedAgeManager/correctedAgeUtils';


interface AppointmentsProps {
  recommendedCheckDate: string;
  recommendedSupportWorkshopDate: string;
}

const Appointments: React.FC<AppointmentsProps> = ({
  recommendedCheckDate,
  recommendedSupportWorkshopDate
}) => {


  return (
  <div data-testid="appointments">
    <table style={{ width: '100%', borderCollapse: 'collapse', direction: 'rtl', marginBottom: '10px', marginRight: 20 }}>
      <tbody>
        <tr data-testid="appointments-check-row">
          <td style={{ textAlign: 'right', paddingRight: '10px' }}>
            <span data-testid="appointments-check-date" style={getDateStyle(recommendedCheckDate)}>
              {recommendedCheckDate}
              {isDatePassed(recommendedCheckDate) && (
                <span data-testid="appointments-check-pastdue" style={pastDueStyle}>
                  {getDatePastDueText(recommendedCheckDate)}
                </span>
              )}
            </span>
          </td>
          <td style={{ textAlign: 'left', width: '1%', paddingLeft: '8px', paddingRight: '8px', whiteSpace: 'nowrap' }}>:</td>
          <td data-testid="appointments-check-label" style={{ textAlign: 'right', paddingRight: '10px', width: '99%' }}>
            תור למרפאת פגים
          </td>
        </tr>

        <tr data-testid="appointments-workshop-row">
          <td style={{ textAlign: 'right', paddingRight: '10px' }}>
            <span data-testid="appointments-workshop-date" style={getDateStyle(recommendedSupportWorkshopDate)}>
              {recommendedSupportWorkshopDate}
              {isDatePassed(recommendedSupportWorkshopDate) && (
                <span data-testid="appointments-workshop-pastdue" style={pastDueStyle}>
                  {getDatePastDueText(recommendedSupportWorkshopDate)}
                </span>
              )}
            </span>
          </td>
          <td style={{ textAlign: 'left', width: '1%', paddingLeft: '8px', paddingRight: '8px', whiteSpace: 'nowrap' }}>:</td>
          <td data-testid="appointments-workshop-label" style={{ textAlign: 'right', paddingRight: '10px', width: '99%' }}>
            תור לסדנת ליווי התפתחותי
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);
  
};

export default Appointments;